var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "appranking-page" }, [
    _c("div", { staticClass: "ranking-block" }, [
      _c("div", { staticClass: "ranking-head" }, [
        _c("div", { staticClass: "frist-line" }, [
          _c("div", { staticClass: "text" }, [
            _c("div", { staticClass: "text-pram" }, [_vm._v("发布人：")]),
            _vm._v(" "),
            _c("div", { staticClass: "text-name" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.info.content[0].dept_name) +
                  "|" +
                  _vm._s(_vm.info.content[0].login_name) +
                  "\n          "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "time" }, [
            _vm._v(_vm._s(_vm.info.content[0].fbsj)),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "second-line" }, [
          _c("div", { staticClass: "second-line-text" }, [
            _vm._v("收件人：" + _vm._s(_vm.info.content[0].dept_names)),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "table-block",
          on: {
            click: function ($event) {
              return _vm.popu("close")
            },
          },
        },
        [
          _c("div", {
            staticClass: "html-data",
            domProps: { innerHTML: _vm._s(_vm.info.content[0].content) },
          }),
        ]
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.showpopu,
            expression: "!showpopu",
          },
        ],
        staticClass: "fixed-bottom",
        on: {
          click: function ($event) {
            return _vm.popu("open")
          },
        },
      },
      [
        _c("div", {}, [
          _vm._v(_vm._s(_vm.info.content[0].haveread.length) + "人已读"),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "see-block" },
          [
            _c(
              "el-button",
              {
                staticClass: "see-block-button",
                attrs: { type: "primary", round: "" },
              },
              [_vm._v("查看状况")]
            ),
          ],
          1
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showpopu,
            expression: "showpopu",
          },
        ],
        staticClass: "see-result",
      },
      [
        _c("div", { staticClass: "result-head" }, [
          _c("div", { staticClass: "result-change" }, [
            _c(
              "div",
              {
                class: [
                  _vm.isseeblock ? "result-change-pram-active" : "",
                  "result-change-pram",
                ],
                on: {
                  click: function ($event) {
                    return _vm.changesee("1")
                  },
                },
              },
              [
                _vm._v(
                  "\n          已读" +
                    _vm._s(_vm.info.content[0].haveread.length) +
                    "\n        "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                class: [
                  !_vm.isseeblock ? "result-change-pram-active" : "",
                  "result-change-pram",
                ],
                on: {
                  click: function ($event) {
                    return _vm.changesee("2")
                  },
                },
              },
              [
                _vm._v(
                  "\n          未读" +
                    _vm._s(_vm.info.content[0].noread.length) +
                    "\n        "
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "icon",
              on: {
                click: function ($event) {
                  return _vm.popu("close")
                },
              },
            },
            [
              _c("img", {
                staticClass: "icon-img",
                attrs: {
                  src: require("../../images/arrow-right-666.png"),
                  alt: "",
                },
              }),
            ]
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isseeblock,
                expression: "isseeblock",
              },
            ],
            staticClass: "seeed",
          },
          _vm._l(_vm.info.content[0].haveread, function (item, index) {
            return _c("div", { key: index, staticClass: "name-block" }, [
              _vm._v("\n        " + _vm._s(item.login_name) + "\n      "),
            ])
          }),
          0
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.isseeblock,
                expression: "!isseeblock",
              },
            ],
            staticClass: "seeed",
          },
          _vm._l(_vm.info.content[0].noread, function (item, index) {
            return _c("div", { key: index, staticClass: "noread-name-block" }, [
              _vm._v("\n        " + _vm._s(item.login_name) + "\n      "),
            ])
          }),
          0
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }